import Immutable from 'immutable';


const SessionRecord = Immutable.Record({
    valid: false,
    login: {
        user: null,
        storeId: null,
    }
});


export default SessionRecord;


// WEBPACK FOOTER //
// ./src/data/record/SessionRecord.js